import { Container, OwnerImg, ImageContainer, SchoolsContainer, SchoolImg } from './styles.ts';
import ownerImageSrc from './images/owner-image.png';
import angl from './images/7.png';
import math from './images/10.png';
import litera from './images/11.png';
import history from './images/9.png';
import society from './images/12.png';
import russian from './images/8.png';
import { FlexContainer } from '../../../../../../../ui/index.ts';

export function OwnerImage() {
  return (
    <Container flexDirection="column" justifyContent="center" alignItems="center">
      <SchoolsContainer gridTemplateRows="repeat(3, max-content)">
        <FlexContainer justifyContent="spaceBetween" alignItems="center" gap="12">
          <SchoolImg src={litera} />
          <SchoolImg src={angl} />
        </FlexContainer>
        <FlexContainer justifyContent="spaceBetween" alignItems="center" gap="12">
          <SchoolImg src={math} />
          <SchoolImg src={society} />
        </FlexContainer>
        <FlexContainer justifyContent="spaceBetween" alignItems="center" gap="12">
          <SchoolImg src={history} />
          <SchoolImg src={russian} />
        </FlexContainer>
      </SchoolsContainer>
      <ImageContainer>
        <OwnerImg src={ownerImageSrc} />
      </ImageContainer>
    </Container>
  );
}
